import React, {useEffect, useState, useRef} from 'react';
import QuadralContainer from "@quadral/quadral-component-common/dist/components/container";
import QuadralBadge from "@quadral/quadral-component-common/dist/components/badge"
import QuadralCard from '@quadral/quadral-component-common/dist/components/card';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralAccordion from '@quadral/quadral-component-common/dist/components/accordion';
import QuadralTypography from '@quadral/quadral-component-common/dist/components/typography';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faPlus } from '@fortawesome/free-solid-svg-icons';

export default React.memo(function SupportingDocumentList({selectedIndex, emptyRefusalModal, data, setAddDocModalOpen, setAddNewDocModalOpen, setAssociationDisplay, displayDocumentList, ...props}) {
    const [receptionBox, setReceptionBox] = useState([]);
    const [otherData, setOtherData] = useState([]);
    const [showAssociateButton, setShowAssociateButton] = useState(false);
    const refsMap = useRef({});

    useEffect(() => {
        emptyRefusalModal();
    },[selectedIndex, emptyRefusalModal])
        
        
    useEffect(() => {
        if (data) {
            const { receptionBox: rb, ...rest } = data;
            setReceptionBox(rb || []);
            setOtherData(rest);
        }
    }, [data]);

    useEffect(() => {
        if (props.receptionBoxDisplay && props.isAnySelected) {
            setShowAssociateButton(true);
        } else {
            setShowAssociateButton(false);
        }
    }, [props.receptionBoxDisplay, props.isAnySelected]);


    return (
        <div style={{
            maxHeight: "650px",
            overflow: 'auto',
            opacity: displayDocumentList ? "1" : "0",
            transition: "max-width 0.4s ease-in-out, opacity 0.4s ease-in-out",
            padding: '1rem',
        }}>
            {receptionBox && (<>
                <QuadralTypography variant='dataLabel'> Boîte de tri </QuadralTypography>
                <QuadralButton
                    fullWidth
                    label='Charger un fichier'
                    startIcon={<FontAwesomeIcon icon={faCloudArrowUp}/>}
                    onClick={() => { setAddDocModalOpen(true) }}
                    style={{
                        opacity: displayDocumentList ? "1" : "0",
                        marginRight: '8px',
                        margin: '0.5rem 0'
                    }}
                />
                <QuadralContainer>
                    {receptionBox.map((doc, docIndex) => {
                        if (!refsMap.current[`reception-${docIndex}`]) {
                            refsMap.current[`reception-${docIndex}`] = React.createRef();
                        }
                        
                        return(
                        <QuadralContainer 
                            orientation='row' 
                            key={`reception-${docIndex}`}
                            ref={props.selectedCurrentPerson === docIndex && selectedIndex === docIndex ? refsMap.current[`reception-${docIndex}`] : null}
                            sx={{padding: '0.5rem'}} 
                            onClick={(event) => {
                                event.stopPropagation();
                                if (doc.files?.length || doc.isTooLarge) {
                                    props.displayDocumentDetail(doc.personId, doc, docIndex)
                                }
                            }}
                        >
                            <QuadralCard
                                variant='small'
                                sx={{ width: '100%', minWidth: 'auto', ...(!((props.selectedCurrentPerson === doc.personId) && (selectedIndex === docIndex)) && { backgroundColor: '#fff' }) }}
                            >
                                <QuadralContainer orientation='column' size={8} className='doc-category align-self-center'>
                                    <span>{doc.name}</span>
                                </QuadralContainer>
                                {props.hasReceptionFiles && (
                                    <QuadralContainer orientation='column' size={4} className='doc-status align-self-center'>
                                        {(doc.files?.length) ? (
                                            <span>{doc.files?.length} pages</span>
                                        ) : (
                                            <span>Erreur taille</span>
                                        )}                                                    
                                    </QuadralContainer>
                                )}
                            </QuadralCard>
                        </QuadralContainer>
                        )
                    })}
                </QuadralContainer>
            </>)}

            {otherData && (<>
                <QuadralTypography variant='dataLabel'> Pièces justificatives des membres du foyer </QuadralTypography>
                <QuadralButton
                    fullWidth
                    label='Créer une nouvelle pièce justificative'
                    startIcon={<FontAwesomeIcon icon={faPlus}/>}
                    onClick={() => setAddNewDocModalOpen(true) }
                    style={{
                        opacity: displayDocumentList ? "1" : "0",
                        fontWeight: "bold",
                        transition: "opacity 0.3s ease-in-out",
                        margin: '0.5rem 0',
                    }}
                />
                {
                    <div style={{
                        maxHeight: showAssociateButton ? "100px" : "0px",
                        overflow: "hidden",
                        transition: "max-height 0.3s ease-in-out"
                    }}>
                        <QuadralButton
                            fullWidth
                            label='Associer à une nouvelle pièce justificative'
                            startIcon={<FontAwesomeIcon icon={faPlus}/>}
                            onClick={() => {setAssociationDisplay(true); setAddNewDocModalOpen(true);}}
                            style={{
                                opacity: displayDocumentList ? "1" : "0",
                                fontWeight: "bold",
                                transition: "opacity 0.3s ease-in-out",
                                margin: '0.5rem 0',
                            }}
                        />
                    </div>
                }
                {Object.entries(otherData).map(([personId, documents]) => (<>
                    <QuadralAccordion
                        title={
                            <div style={{display: 'flex', fontWeight: 'bold'}}>
                                <span style={{marginRight: '5px'}}>{props.getPersonGenre(personId)}</span>
                                <span>{props.getPersonName(personId)}</span>
                            </div>
                        }
                        defaultExpanded
                        style={{marginBottom: '6px'}}
                    >
                        <QuadralContainer>
                            {documents.map((doc, docIndex) => {
                                const refKey = `${personId}-${docIndex}`;
                                if (!refsMap.current[refKey]) {
                                    refsMap.current[refKey] = React.createRef();
                                }
                                return (
                                    <QuadralContainer
                                        orientation='row'
                                        key={doc.globalIndex}
                                        ref={props.selectedCurrentPerson === personId && selectedIndex === docIndex ? refsMap.current[refKey] : null}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            if (!(doc.pages === 0)) {
                                                props.displayDocumentDetail(personId, doc, docIndex)
                                            }
                                        }}
                                        sx={{padding: '0.25rem'}}
                                    >
                                        <QuadralCard
                                            variant='small'
                                            sx={{ width: '100%', minWidth: 'auto', ...(!((props.selectedCurrentPerson === personId) && (selectedIndex === docIndex)) && { backgroundColor: '#fff' }) }}
                                            title={props.getCategory(doc)}
                                        >
                                            <QuadralBadge
                                                sx={{minWidth: 'auto'}}
                                                icon={props.getStatusIcon(doc)}
                                                label={props.getStatus(doc)}
                                                color={doc.status === 'valide' ? 'success'
                                                    : doc.status === 'refuse' ? 'error'
                                                    : doc.status === 'a_valider' ? 'info'
                                                    : doc.status === 'attente_verification' ? 'info'
                                                    : (doc.status === 'a_fournir' && props.receptionBoxDisplay) ? 'secondary'
                                                    : 'secondary'
                                                }
                                            />
                                        </QuadralCard>
                                    </QuadralContainer>
                                )
                            })}
                        </QuadralContainer>
                    </QuadralAccordion>
                </>))}
            </>)}
        </div>
    )
});